module.exports = __webpack_public_path__ + "media/images/costumes/top/wasou/thumbnail-6-524315c3eefc51fb7ec484e480a2e061.jpg";